import { createFileRoute } from '@tanstack/react-router';
import { AdminBetaRequestsScreen, type BetaKindFilter, type BetaStatusFilter } from '@/features/admin/AdminBetaRequestsScreen';

type Search = { status?: BetaStatusFilter; kind?: BetaKindFilter; page?: number; open?: number };

const STATUSES: BetaStatusFilter[] = ['new', 'approved', 'declined', 'all'];
const KINDS: BetaKindFilter[] = ['all', 'beta', 'demo'];

/** ?status= (New by default: what needs an answer), ?kind= (Beta or Demo),
 *  ?page=, and ?open=<id> to open one request's details (the Overview's
 *  waiting list links here). */
export const Route = createFileRoute('/_app/admin/beta-requests')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    status: STATUSES.includes(s.status as BetaStatusFilter) ? (s.status as BetaStatusFilter) : undefined,
    kind: KINDS.includes(s.kind as BetaKindFilter) && s.kind !== 'all' ? (s.kind as BetaKindFilter) : undefined,
    page: typeof s.page === 'number' && s.page >= 1 ? Math.floor(s.page) : undefined,
    open: typeof s.open === 'number' && s.open >= 1 ? Math.floor(s.open) : undefined,
  }),
  component: () => {
    const { status, kind, page, open } = Route.useSearch();
    return <AdminBetaRequestsScreen status={status ?? 'new'} kind={kind ?? 'all'} page={page ?? 1} openId={open ?? null} />;
  },
});
